<h3 mat-dialog-title>Confirm New Doc Version</h3>
<mat-dialog-content class="mat-dialog-content-spacing-vertical">
  <div class="message">
    @if (doc.fileName !== fileName) {
      <h2>WARNING</h2>
      <p>The name of the provided file (<strong>{{fileName}}</strong>) is different from the document in FTF and will be renamed to match.</p>
    }
    <p>Please confirm the upload of the new version of the file <strong>{{ doc.fileName }}</strong>.</p>
  </div>
  <ip-detail [closeable]="false" [onlyKeys]="['title', 'docType', 'docSubtype', 'documentDate']" title="Details" [detail]="detail"></ip-detail>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button mat-raised-button mat-dialog-close (click)="onCancelClick()">Cancel</button>
  <button
    mat-button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="{ value: { item, doc } }"
    cdkFocusInitial>
    Confirm
  </button>
</mat-dialog-actions>